import { createTestIds } from '../../utils';

export const getListToolbarTestIds = createTestIds('list-toolbar', [
  'view-selector',
  'count',
  'heading',
  'info',
  'create-new',
  'search-input',
  'search-button',
  'wrap-button'
] as const);
